module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_07.0441bf33.png";